import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { ControlResponse } from '@/main/models/response/controlResponse';

// Redux
import { saveControlsByScreen, GetControlsByScreen } from './index';

// Api's
import { controlApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getControlsByScreenSaga({ payload }: GetControlsByScreen) {
  try {
    const response: AxiosResponse<Result<ControlResponse[]>> = yield call(
      controlApi.getControlsByScreenApi,
      payload.guidScreen
    );
    if (response.data.result) {
      yield put(saveControlsByScreen(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveControlsByScreen(null, true, resultError.messagesDataError));
    }
  }
}
